import { gtm } from '@lessonnine/marketing-tracker';

gtm.load();
